<template lang="html">
  <div>



    <div class="pop-up">
      <h2 class="title title-26">{{$t('formulario.popup.intro')}}</h2>
      <template v-for="(el, key) in $t('formulario.popup.textos')">
        <h3 class="title title-18">{{el.titulo}}</h3>
        <p>{{el.texto}}</p>
      </template>
    </div>
    </div>

</template>

<script lang="js">
  export default {
    name: 'popup-condiciones',
    props: ['error'],
    mounted() {

    },
    data() {
      return {
        popup: false
      }
    },
    methods: {
      launchOk: function () {
        this.popup = false;
        this.$emit('launch');
      }
    },
    computed: {

    }
  }
</script>

<style scoped>
  .pop-up {
    width: 100%;
    background: white;
    display: inline-block;
    position: relative;
    text-align: center;
    margin-top: 20px;
    max-width: 768px;
  }

  .title-26 {
    margin-bottom: 10px;
    font-size: 18px;
  }

  .title {
    text-align: left;
    font-size: 16px;
  }

  p {
    font-size: 13px;
    text-align: left;
  }

  .show-popup {
    font-size: 12px;
    color: #054279;
    text-decoration: underline;
    margin-top: 10px;
    display: inline-block;
    width: 100%;
  }

  .show-popup[error="true"] {
    color: red;
  }

  .btn {
    max-width: 260px;
    margin: 0 auto;
    display: inline-block;
  }

  @media screen and (max-width: 500px) {

    .pop-up {
      padding: 15px;
    }

    .title-26 {
      font-size: 18px;
      line-height: 20px;
    }

    .title-18 {
      font-size: 14px;
    }

    .btn {
      padding: 10px 20px;
      font-size: 12px;
    }

    p {
      font-size: 10px;
      line-height: 12px;
    }
  }

</style>


// WEBPACK FOOTER //
// src/components/parts/popup-condiciones.vue